import ReturnList from "@/views/return-list.vue";
import ReturnSchedule from "@/views/returnschedule.vue";
import ReturnConfirmation from "@/views/return-confirmation.vue";
import Store from "@/store.js";

export default [
  {
    path: "/retorno/:organizationId",
    name: "return",
    component: ReturnList,
    beforeEnter: (to, from, next) => {
      if (!Store.getters.token) {
        Store.dispatch("set_to", to);
        Store.dispatch("set_modalLogin", true);
      } else {
        next();
      }
    }
  },
  {
    path: "/retorno/:organizationId/:agendaId",
    name: "return_horario",
    component: ReturnSchedule,
    beforeEnter: (to, from, next) => {
      if (!Store.getters.token) {
        Store.dispatch("set_to", to);
        Store.dispatch("set_modalLogin", true);
      } else {
        next();
      }
    }
  },
  {
    path: "/retorno/confirmacao",
    name: "return_confirmacao",
    component: ReturnConfirmation,
    beforeEnter: (to, from, next) => {
      if (Store.getters.token === "") {
        Store.dispatch("set_to", to);
        Store.dispatch("set_modalLogin", true);
      }

      next();
    }
  }
];
